import firebase from "firebase/app";
import "firebase/analytics";

const {
  NODE_ENV,
  REACT_APP_TRACKING_ENVS,
  REACT_APP_FIREBASE_APP_ID,
  REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_SENDER_ID,
  REACT_APP_FIREBASE_MEASURMENT_ID,
} = process.env;

const trackingEnvs = REACT_APP_TRACKING_ENVS
  ? REACT_APP_TRACKING_ENVS.split(",").map((x) => x.trim())
  : ["staging", "production"];

// To test in your local env, change REACT_APP_TRACKING_ENVS to include
// development in a comma separeted string
export const initializeEventLogger = () => {
  if (trackingEnvs.includes(NODE_ENV)) {
    // Initialize Firebase
    const firebaseConfig = {
      apiKey: REACT_APP_FIREBASE_API_KEY,
      authDomain: `${REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
      databaseURL: `https://${REACT_APP_FIREBASE_PROJECT_ID}.firebaseio.com`,
      projectId: `${REACT_APP_FIREBASE_PROJECT_ID}`,
      storageBucket: `${REACT_APP_FIREBASE_PROJECT_ID}.appspot.com`,
      messagingSenderId: REACT_APP_FIREBASE_SENDER_ID,
      appId: REACT_APP_FIREBASE_APP_ID,
      measurementId: `${REACT_APP_FIREBASE_MEASURMENT_ID}`,
    };
  
    firebase.initializeApp(firebaseConfig);
    firebase.analytics();
  }

};

export const logEvent = (event: string, data: {}) => {
  if (trackingEnvs.includes(NODE_ENV)) firebase.analytics().logEvent(event, {...data, env: NODE_ENV});
};
